export default {
  dayOfWeek () {
    return this.$dayOfWeek(this.schedule.date)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/transfer/resources/computed.js